<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta && $route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!($route.meta && $route.meta.keepAlive)" />
    <Loading></Loading>
    <Toast></Toast>
    <OpenApp />
    <SlideVerify />
    <MessagePopup />
    <LoginByPhonePopup />
  </div>
</template>

<script>
import Toast from "./components/Toast"
import Loading from "./components/Loading"
import OpenApp from "./components/OpenApp"
import SlideVerify from "./components/SlideVerify"
import MessagePopup from "./components/MessagePopup"
import LoginByPhonePopup from "./components/LoginByPhonePopup"
import getParamsFromUrl from "@/utils/getParamsFromUrl"
import { mapActions, mapMutations } from "vuex"
import { redirectWhiteName } from "@/config"

export default {
  name: "app",
  components: {
    Toast,
    Loading,
    OpenApp,
    SlideVerify,
    MessagePopup,
    LoginByPhonePopup
  },
  methods: {
    ...mapMutations({
      setActivityId: "activityInfo/setActivityId"
    }),
    ...mapActions({
      getSystemInfo: "getSystemInfo",
      getUserInfo: "userInfo/getUserInfo",
      initNfPluseShare: "activityInfo/initNfPluseShare"
    }),
    redirectRoute({ routeName }) {
      this.$router.replace({ name: routeName })
    },
    getUrlParams() {
      const params = getParamsFromUrl()
      const hasRoute = !!params.route
      const isWhiteNameRoute = () => {
        const hash = window.location.hash
        const reg = /#\/([^?]*)/
        const matchArr = hash.match(reg) || []
        const routeName = matchArr[1] || ""
        return redirectWhiteName[routeName]
      }
      if (params.id) {
        this.setActivityId(params.id)
      }
      if (hasRoute) {
        this.redirectRoute({ routeName: params.route })
      } else if (isWhiteNameRoute()) {
        return
      } else {
        delete params.route
        this.$router.replace({ path: "/" })
      }
    },
    initActivityId() {
      const sessionActivityId = window.sessionStorage.getItem("NFPLUS_YOUNGREPORTER_ACTIVITY_ID") || ""
      sessionActivityId && this.setActivityId(sessionActivityId)
    },
    async init() {
      this.initActivityId()
      this.getUrlParams()
      await this.getSystemInfo()
      this.initNfPluseShare()
      // await this.getUserInfo()
    }
  },
  created() {
    this.init()
  }
}
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  background: #ffffff;
}
</style>
